import { Route, Routes, BrowserRouter, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const isValidUrl = (url: string) => {
    try {
        return Boolean(new URL(url));
    } catch (e) {
        return false;
    }
};

export default function App() {
    return (
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    );
}

function AppRouter() {
    return (
        <Routes>
            {/* <Route path="/" element={<RedirectToNativeApp />}></Route> */}
            <Route path="*" element={<RedirectToNativeApp />} />
        </Routes>
    );
}

function RedirectToNativeApp() {
    let [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const redirectTo = searchParams.get('to');
        console.log('redirectTo', redirectTo);
        if (!redirectTo) {
            window.close();
            return;
        }

        if (!isValidUrl(redirectTo)) {
            window.close();
            return;
        }

        window.location.replace(redirectTo);

        // Attempt to close webview after redirect
        setTimeout(() => {
            window.close();
        }, 1000);

        setTimeout(() => {
            const redirectFail = searchParams.get('fail');
            if (!redirectFail) {
                return;
            }
            if (!isValidUrl(redirectFail)) {
                window.location.replace('about:blank');
                return;
            }

            window.location.replace(redirectFail);
        }, 1000);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App">
            <div>Идёт обработка</div>
        </div>
    );
}
